// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"aebd5aa7","977":"29392f60"}[chunkId] + ".chunk.js";
};